import { gql } from "@apollo/client";

export const GET_STAFF_DETAILS = gql`
  query GetStaffDetails($filter: EmployeesFilterInputType, $audit_id: String) {
    getEmployees(filter: $filter, audit_id: $audit_id) {
      statusCode
      success
      message
      totalCount
      currentPage
      totalPages
      data {
        id
        employee_id
        employee_data_id
        first_name
        middle_name
        last_name
        name
        gender
        start_date
        termination_date
        termination_reason
        emails {
          email
          type
          is_primary
        }
        roles {
          role_id
          role_name
          role_description
        }
        employments {
          job_title
          effective_date
          employment_type
        }
        manager {
          id
        }
        avatar
        in_scope
        scope_reason
        employee_sync_status {
          id
          key
          title
          type
        }
        account_category {
          id
          key
          title
          type
        }
        user_fetching_info {
          id
          type
          key
          title
          name
        }
        work_email
        is_complete
      }
    }
  }
`;

export const GET_SYNC_DATA = gql`
  query GeTrutoData {
    getTrutoData {
      message
    }
  }
`;

export const GENERATE_TRUTO_LINK_TOKEN = gql`
  mutation generateTrutoLinkToken {
    generateTrutoLinkToken {
      message
      linkToken
    }
  }
`;

export const GET_AVAILABLE_INTEGRATIONS = gql`
  query GetAvailableIntegrations($category: String) {
    getAvailableIntegrations(category: $category) {
      message
      list {
        key
        label
        category
      }
    }
  }
`;

export const UPDATE_EMPLOYEE_STATUS = gql`
  mutation updateEmployeeNotInScopeStatus(
    $status: Boolean!
    $employeeId: String!
    $reason: String!
  ) {
    updateEmployeeNotInScopeStatus(
      status: $status
      employeeId: $employeeId
      reason: $reason
    ) {
      message
    }
  }
`;

export const UPDATE_EMPLOYEE = gql`
  mutation UpdateEmployee(
    $employeeId: String!
    $managerId: String
    $jobTitle: String
    $employmentStatus: String
    $terminationDate: String
  ) {
    updateEmployee(
      employeeId: $employeeId
      managerId: $managerId
      jobTitle: $jobTitle
      employmentStatus: $employmentStatus
      terminationDate: $terminationDate
    ) {
      message
    }
  }
`;

export const UPSERT_EMPLOYEES_MUTATION = gql`
  mutation UpsertEmployees($employees: [InsertBulkEmployeesInput!]!) {
    upsertEmployees(employees: $employees) {
      message
    }
  }
`;

export const UPDATE_EMPLOYEE_PROFILE_METADATA = gql`
  mutation UpdateEmployee_Profile_Metadata(
    $email: String!
    $linkedin_url: String!
  ) {
    updateEmployeeProfileMetadata(email: $email, linkedin_url: $linkedin_url) {
      success
      message
    }
  }
`;

export const GET_EMPLOYEE_PROFILE_METADATA = gql`
  query GetEmployeeProfileMetadata($email: String!) {
    getEmployeeProfileMetadata(email: $email) {
      linkedin_url
      success
    }
  }
`;

export const GET_PEOPLE_CHECKS = gql`
  query getPeopleChecks($active_check_category: String!) {
    getPeopleChecks(active_check_category: $active_check_category) {
      active_check_id
      active_check_name
      active_check_description
      active_check_category
      active_check_type
      monitor_type
      status
    }
  }
`;

export const GET_EMPLOYEE_CHECK_STATUSES = gql`
  query getEmployeeCheckStatuses {
    getEmployeeCheckStatuses {
      employee_id
      total_checks_count
      passed_checks_count
      failed_checks_count
      disabled_checks_count
      checks {
        active_check_id
        check_type
        status
        status_reason
        created_at
        updated_at
        evidence_id
        evidence_created_at
        evidence_updated_at
      }
    }
  }
`;

// New APIs for People Check Exceptions
export const CREATE_GLOBAL_PEOPLE_CHECK_EXCEPTION = gql`
  mutation createGlobalPeopleCheckException(
    $exception_data: PeopleCheckExceptionInput!
  ) {
    createGlobalPeopleCheckException(exception_data: $exception_data) {
      success
      message
      data {
        id
        active_check_id
        scope
        employee_email
        reason
        exception_valid_till
        rego_valid_from
        rego_valid_till
        created_at
        file_id
      }
      disabledResourceCount
    }
  }
`;

export const CREATE_RESOURCE_PEOPLE_CHECK_EXCEPTION = gql`
  mutation createResourceLevelPeopleCheckException(
    $exception_data: ResourcePeopleCheckExceptionInput!
  ) {
    createResourceLevelPeopleCheckException(exception_data: $exception_data) {
      success
      message
      data {
        id
        active_check_id
        scope
        employee_email
        reason
        exception_valid_till
        rego_valid_from
        rego_valid_till
        created_at
      }
      disabledGlobalCount
      disabledResourceCount
      totalCreated
    }
  }
`;

export const DELETE_PEOPLE_CHECK_EXCEPTION = gql`
  mutation deletePeopleCheckException($ids: [Int!]!) {
    deletePeopleCheckException(ids: $ids) {
      success
      message
    }
  }
`;

export const GET_PEOPLE_CHECK_EXCEPTIONS = gql`
  query getPeopleCheckExceptions(
    $filter: PeopleCheckExceptionFilterInput
    $page: Int
    $limit: Int
  ) {
    getPeopleCheckExceptions(filter: $filter, page: $page, limit: $limit) {
      success
      message
      data {
        id
        active_check_id
        scope
        employee_email
        reason
        exception_valid_till
        rego_valid_from
        rego_valid_till
        created_at
        is_active
        file_id
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_PEOPLE_CHECK_EXCEPTION_BY_ID = gql`
  query getPeopleCheckExceptionById($id: Int!) {
    getPeopleCheckExceptionById(id: $id) {
      success
      message
      data {
        id
        active_check_id
        scope
        employee_email
        reason
        exception_valid_till
        rego_valid_from
        rego_valid_till
        created_at
      }
    }
  }
`;

// Additional APIs from employee.service.js
export const UPDATE_EMPLOYEE_ROLES = gql`
  mutation updateEmployeeRoles($email: String!, $roleIds: [String!]!) {
    updateEmployeeRoles(email: $email, roleIds: $roleIds) {
      success
      message
    }
  }
`;

export const SEND_REMINDER = gql`
  mutation SendReminder($type: ReminderType!, $options: ReminderOptionsInput) {
    sendReminderToEmployee(type: $type, options: $options) {
      success
      message
    }
  }
`;

export const DELETE_EMPLOYEE_ROLES = gql`
  mutation deleteEmployeeRoles($email: String!, $roleIds: [String!]!) {
    deleteEmployeeRoles(email: $email, roleIds: $roleIds) {
      success
      message
    }
  }
`;

export const GET_EVIDENCES_BY_EMPLOYEE = gql`
  query getEvidencesByEmployee(
    $employeeName: String!
    $employeeEmail: String!
    $end_time: DateTime
    $check_id: Int
  ) {
    getEvidencesByEmployee(
      employeeName: $employeeName
      employeeEmail: $employeeEmail
      end_time: $end_time
      check_id: $check_id
    ) {
      id
      check_id
      path
      entity_id
      entity_type
      checkmate_metadata
      created_at
      updated_at
    }
  }
`;

export const GET_EVIDENCES_BY_EMPLOYEES_BATCH = gql`
  query getEvidencesByEmployeesBatch(
    $employeeEmails: [String!]!
    $audit_id: String
    $end_time: DateTime
    $check_id: Int
  ) {
    getEvidencesByEmployeesBatch(
      employeeEmails: $employeeEmails
      audit_id: $audit_id
      end_time: $end_time
      check_id: $check_id
    )
  }
`;

export const GET_ROLE_ID_BY_DESCRIPTION = gql`
  query getRoleIdByDescription($roleDescription: String!) {
    getRoleIdByDescription(roleDescription: $roleDescription)
  }
`;

export const GET_ROLE_NAME_BY_DESCRIPTION = gql`
  query getRoleNameByDescription($roleDescription: String!) {
    getRoleNameByDescription(roleDescription: $roleDescription)
  }
`;

export const UPDATE_EMPLOYEE_METADATA = gql`
  mutation updateEmployeeMetadata(
    $email: String!
    $type: String!
    $metadata: String!
  ) {
    updateEmployeeMetadata(email: $email, type: $type, metadata: $metadata) {
      success
      message
    }
  }
`;

// Legacy mutation names for backward compatibility
export const INSERT_PEOPLE_CHECK_EXCEPTION =
  CREATE_GLOBAL_PEOPLE_CHECK_EXCEPTION;
export const UPDATE_PEOPLE_CHECK_EXCEPTION =
  CREATE_GLOBAL_PEOPLE_CHECK_EXCEPTION;

export const GET_PEOPLE_CHECK_BY_ID = gql`
  query getPeopleCheckById($active_check_id: Int!) {
    getPeopleCheckById(active_check_id: $active_check_id) {
      active_check_id
      active_check_name
      active_check_description
      active_check_category
      active_check_type
      monitor_type
    }
  }
`;

export const BULK_IMPORT_EMPLOYEES = gql`
  mutation BulkImportEmployees($employees: [EmployeesCreateInputType!]!) {
    bulkImportEmployees(employees: $employees) {
      statusCode
      success
      message
      totalCount
      successCount
      failureCount
      errors {
        index
        error
      }
    }
  }
`;

export const CREATE_EMPLOYEE = gql`
  mutation CreateEmployee($input: EmployeesCreateInputType!) {
    createEmployee(input: $input) {
      statusCode
      success
      message
      data {
        id
        employee_id
        first_name
        last_name
        name
        work_email
        start_date
      }
    }
  }
`;

export const UPDATE_EMPLOYEE_DETAILS = gql`
  mutation UpdateEmployeeDetails($input: [EmployeesUpdateInputType!]!) {
    updateEmployeeDetails(input: $input) {
      statusCode
      success
      message
      data {
        id
        success
        error
      }
    }
  }
`;

export const GET_IDP_EMPLOYEES_COUNT = gql`
  query GetIdpEmployeesCount {
    getIdpEmployeesCount {
      success
      count
    }
  }
`;

export const DELETE_EMPLOYEE = gql`
  mutation DeleteEmployee($input: EmployeesDeleteInputType!) {
    deleteEmployee(input: $input) {
      statusCode
      success
      message
      data {
        id
        success
        error
      }
    }
  }
`;
